<script setup lang="ts">
import { useRouter } from 'vue-router';
import Status from '@/components/Status.vue';
import { RouteNames } from '@/data/routes';

// -----
// Setup
// -----

const router = useRouter();

// -------
// Methods
// -------

const onNextClick = () => {
  router.push({ name: RouteNames.OWNERS.INDEX });
};
</script>

<template>
  <Status
    iconType="success"
    text="Verification Complete"
    ctaLabel="Next"
    :ctaMethod="onNextClick"
  />
</template>
